<template>
<el-dialog
    width="600px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
  <div class="title">{{title}}</div>
 <el-form ref="form" :model="form" label-width="100px" :rules="rules" label-position="left">
  <el-form-item label="导入方式：" v-if="type==1" prop="importType">
    <el-radio-group v-model="form.importType">
      <el-radio :label="2">税局导入</el-radio>
      <el-radio :label="1">模板导入</el-radio>
    </el-radio-group>
     <div class="taxTip" v-if="form.importType==2">
      在个税扣缴的电子税务局客户端首页进入<span style="color:#FF6010">综合所得申报界面</span>，
      选择<span style="color:#FF6010">“导出申报表”—“标准表样”</span>，选择导出<span style="color:#FF6010">“个人所得税扣缴申报表”</span>。
    </div>
  </el-form-item>
  <el-form-item label="文件上传：" v-if="type==1">
    <el-upload
      class="upload-demo"
      action=""
      :auto-upload="false"
      drag
      accept=".xls,.xlsx"
      :on-change="handleChange"
      :file-list="files">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>   
    <el-button type="text" @click="downlodaTemplate" v-if="form.importType==1">模板下载</el-button>
  </el-form-item>
  <el-form-item label="导出方式：" v-if="type==2" prop="exportType">
    <el-radio-group v-model="form.exportType">
      <el-radio :label="2">个税申报表导出</el-radio>
      <el-radio :label="1">系统导出</el-radio>
    </el-radio-group>
  </el-form-item>
 </el-form>
  <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {importSalary,exportSalary} from '@/api/index.js'
export default {
  data() {
    return {
      yearPeriod:'',
      files:[],
      rules:{
        exportType:[{ required: true, message: '请选择导出方式', trigger: 'blur' }],
        importType:[{ required: true, message: '请选择导入方式', trigger: 'blur' },]
      },
      form:{
        exportType:'',
        importType:2
      },
      title:'',
      type:'',  //1 导入 2导出
      visible:false,
    };
  },
  methods:{
    handleChange(file,fileList){
      this.files = [fileList[0]]
      if(fileList.length>1){
        this.$message.error('不支持多文件上传')
        return false
      }
      let testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension = testmsg === 'xls'
			const extension2 = testmsg === 'xlsx'
      if(!extension && !extension2) {
        this.$message({
					message: '上传文件只能是 xls、xlsx格式!',
					type: 'error'
				});
        this.files = []
				return false
			}
    },
    submit(){
      this.$refs.form.validate((valid) => {
        if(valid){
          if(this.type==1){
            if(!this.files.length){
              this.$message.error('请上传文件')
              return
            }
            let formData = new FormData()
            formData.append('type',this.form.importType)
            formData.append('file',this.files[0].raw)
            formData.append('cid',sessionStorage.getItem('cid'));
            formData.append('token',sessionStorage.getItem('token'));
            formData.append('yearPeriod',this.yearPeriod)
            importSalary(formData).then(res=>{
              if(res.data.code==1){
                this.$message.success(res.data.msg)
                this.visible = false
                this.$emit('refsh')
              }
            })
          }
          if(this.type==2){
            let params = {
              type:this.form.exportType,
              yearPeriod:this.yearPeriod
            }
            let cid=sessionStorage.getItem('cid');
		        let token=sessionStorage.getItem('token');
            this.visible = false
            window.open(`${this.$rootUrl}salary/excel/export?cid=${cid}&token=${token}&type=${params.type}&yearPeriod=${params.yearPeriod}`)

            // exportSalary(params).then(res=>{
            //   if(res.data.code==1){
            //     this.$message.success(res.data.msg)
            //     this.$emit('refsh')
            //   }
            // })
          }
        }
      })
    },
    downlodaTemplate(){
      let templateName = ''
      let cid=sessionStorage.getItem('cid');
		  let token=sessionStorage.getItem('token');
      if(this.form.importType==1){
        templateName='系统导出.xls'
        window.open(`${this.$rootUrl}salary/excel/export?cid=${cid}&token=${token}&type=${this.form.importType}&yearPeriod=-1&templateName=${templateName}`)
      }else if(this.form.importType==2){
        // templateName='个税申报表导入_202305.xls'
        // window.location.href = `${this.$rootUrl}voucherChief/download?cid=${cid}&token=${token}&templateName=${templateName}`;
      }else {
        this.$message.error('请选择导入方式')
        return
      }
    },
    openTask(title,type,yearPeriod){
      this.yearPeriod = yearPeriod||''
      this.type = type
      this.title = title
      this.files = []
      this.form.importType = 2
      this.visible = true
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
    },
  }
};
</script>

<style lang="less" scoped>
.taxTip {
  width: 360px;
  padding: 10px 24px 10px 10px;
  box-sizing: border-box;
  background: #FBFBFB;
  font-size: 12px;
  margin-top: 6px;
  color: #999999;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/PayrollExcell.vue